import React, {useState, useCallback, useEffect} from "react";
import "../../components/propertydetails/LiveTourFormModal.css";

const API_BASE = process.env.REACT_APP_API_BASE || "";
const WS_BASE = process.env.REACT_APP_WS_BASE || "";
// The server gives up after 2 minutes (the request becomes a missed call); a little slack for the last poll.
const WAIT_LIMIT_S = 130;
const WHATSAPP_KEY = "ogm_live_whatsapp";

const readStored = (key) => { try { return localStorage.getItem(key) || ""; } catch { return ""; } };
const writeStored = (key, value) => { try { localStorage.setItem(key, value); } catch { /* storage blocked */ } };


function generateRoomName(propertySlug) {
    const rand = Math.random().toString(36).slice(2, 8);
    return `ogm-${propertySlug || "tour"}-${rand}`;
}

function generateSlots() {
    const slots = [];
    const now = new Date();

    for (let d = 0; d < 14; d++) {
        const date = new Date(now);
        date.setDate(now.getDate() + d + 1);
        const dateStr = date.toLocaleDateString("en-IN", {
            weekday: "short", month: "short", day: "numeric",
        });

        for (let h = 9; h <= 20; h++) {
            const slotTime = new Date(date);
            slotTime.setHours(h, 0, 0, 0);
            if (d === 0 && slotTime <= now) continue;

            const iso = slotTime.toISOString().slice(0, 16);
            const hr = h > 12 ? h - 12 : h === 12 ? 12 : h;
            const ap = h >= 12 ? "PM" : "AM";
            const mins = "00";
            slots.push({
                dateStr,
                date: date.toDateString(),
                label: `${hr}:${mins} ${ap}`,
                iso,
            });
        }
    }
    return slots;
}


function StepDetails({form, onChange, onSubmit, loading, error, property, online}) {
    return (
        <div className="ltf-step">
            <div className="ltf-hero">
                <span className="ltf-live-dot" aria-hidden="true"/>
                <span className="ltf-hero-text">Join Live Video Tour</span>
            </div>
            <p className="ltf-property-name">{property?.title}</p>
            {online === false ? (
                <p className="ltf-sub ltf-sub--offline">
                    Our advisors are all busy or offline right now. Leave your details and pick a time — we'll
                    take you through {property?.title || "the property"} on video then.
                </p>
            ) : (
                <p className="ltf-sub">
                    Connect instantly with our property advisor via live video.
                    An advisor usually joins within 2 minutes.
                </p>
            )}

            {error && (
                <div className="ltf-error" role="alert">{error}</div>
            )}

            <div className="ltf-fields">
                <div className="ltf-field">
                    <label htmlFor="ltf-name" className="ltf-label">Full Name *</label>
                    <input
                        id="ltf-name"
                        type="text"
                        className="ltf-input"
                        placeholder="Rahul Sharma"
                        value={form.fullName}
                        onChange={e => onChange("fullName", e.target.value)}
                        autoComplete="name"
                        required
                    />
                </div>

                <div className="ltf-field">
                    <label htmlFor="ltf-email" className="ltf-label">Email</label>
                    <input
                        id="ltf-email"
                        type="email"
                        className="ltf-input"
                        placeholder="rahul@email.com (optional)"
                        value={form.email}
                        onChange={e => onChange("email", e.target.value)}
                        autoComplete="email"
                    />
                </div>

                <div className="ltf-field">
                    <label htmlFor="ltf-wa" className="ltf-label">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="#25D366" aria-hidden="true">
                            <path
                                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                            <path
                                d="M12 0C5.373 0 0 5.373 0 12c0 2.136.557 4.143 1.531 5.886L.05 23.95l6.264-1.464A11.94 11.94 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818c-1.937 0-3.745-.525-5.294-1.441l-.38-.226-3.718.869.934-3.621-.248-.393A9.795 9.795 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182c5.43 0 9.818 4.388 9.818 9.818 0 5.43-4.388 9.818-9.818 9.818z"/>
                        </svg>
                        WhatsApp Number *
                    </label>
                    <div className="ltf-phone-wrap">
                        <span className="ltf-prefix">+91</span>
                        <input
                            id="ltf-wa"
                            type="tel"
                            className="ltf-input ltf-phone-input"
                            placeholder="9876543210"
                            value={form.whatsapp}
                            onChange={e => onChange("whatsapp", e.target.value.replace(/\D/g, "").slice(0, 10))}
                            autoComplete="tel"
                            required
                            inputMode="numeric"
                        />
                    </div>
                    <span className="ltf-hint">We'll send updates on WhatsApp</span>
                </div>
            </div>

            <button
                className="ltf-submit-btn"
                onClick={onSubmit}
                disabled={loading}
            >
                {loading ? (
                    <><span className="ltf-spinner"/> Connecting…</>
                ) : (
                    <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                             strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <polygon points="23 7 16 12 23 17 23 7"/>
                            <rect x="1" y="5" width="15" height="14" rx="2"/>
                        </svg>
                        {online === false ? "Continue to book a slot" : "Start Live Tour"}
                    </>
                )}
            </button>

            <p className="ltf-footer-note">
                {online === false ? "You'll choose a date and time next." : "If no advisor joins in 2 minutes, you can book a slot instead."}
            </p>
        </div>
    );
}


/** Waits for an advisor to accept: the server pushes on the customer's room topic, and polling covers a missed push. */
function StepConnecting({pending, property, onJoined, onMissed, onCancel}) {
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        const t = setInterval(() => setSeconds(x => x + 1), 1000);
        return () => clearInterval(t);
    }, []);

    useEffect(() => {
        if (seconds >= WAIT_LIMIT_S) onMissed();
    }, [seconds, onMissed]);

    useEffect(() => {
        let done = false;
        let ws = null;
        const finish = (fn) => {
            if (done) return;
            done = true;
            try { ws?.close(); } catch { /* already closed */ }
            fn();
        };
        const poll = setInterval(async () => {
            try {
                const r = await fetch(`${API_BASE}/api/live-tour/request-status/${pending.requestId}`);
                const d = await r.json();
                if (d.status === "AGENT_JOINED") finish(() => onJoined(d.agentName));
                else if (d.status === "NO_RESPONSE" || d.status === "CANCELLED") finish(onMissed);
            } catch { /* keep polling */ }
        }, 3000);
        try {
            const url = new URL("/live-queue", WS_BASE || API_BASE || window.location.origin);
            if (!WS_BASE) url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
            ws = new WebSocket(url.toString());
            ws.onopen = () => ws.send(JSON.stringify({action: "subscribe", topic: `customer/${pending.roomName}/call-accepted`}));
            ws.onmessage = (e) => {
                try {
                    const d = JSON.parse(e.data);
                    if (d.accepted === true || d.type === "AGENT_JOINED") finish(() => onJoined(d.agentName));
                } catch { /* not ours */ }
            };
        } catch { /* polling covers it */ }
        return () => { done = true; clearInterval(poll); try { ws?.close(); } catch { /* closed */ } };
    }, [pending.requestId, pending.roomName, onJoined, onMissed]);

    return (
        <div className="ltf-step ltf-connecting" role="status" aria-live="polite">
            <div className="ltf-connecting-pulse" aria-hidden="true"><span/></div>
            <h3 className="ltf-connecting-title">Connecting you to an advisor…</h3>
            <p className="ltf-sub">
                We've let our team know you'd like a live tour of {property?.title || "this property"}.
                Keep this window open.
            </p>
            <div className="ltf-connecting-time">{Math.floor(seconds / 60)}:{String(seconds % 60).padStart(2, "0")}</div>
            <button type="button" className="ltf-link-btn" onClick={onCancel}>Book a slot instead</button>
        </div>
    );
}


function StepSchedule({requestId, property, form, onScheduled, onBack, notice}) {
    const slots = generateSlots();
    const [selDate, setSelDate] = useState(slots[0]?.date || "");
    const [selSlot, setSelSlot] = useState(null);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const dates = [...new Set(slots.map(s => s.date))];
    const noticeBlock = notice ? <div className="ltf-notice" role="status">{notice}</div> : null;
    const daySlots = slots.filter(s => s.date === selDate);
    const activeDateLabel = slots.find(s => s.date === selDate)?.dateStr || "";

    const handleBook = async () => {
        if (!selSlot) {
            setError("Please select a time slot.");
            return;
        }
        setSaving(true);
        setError("");
        try {
            const res = await fetch(`${API_BASE}/api/live-tour/schedule`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    requestId,
                    propertyId: property?.id,
                    propertyTitle: property?.title,
                    customerName: form.fullName,
                    customerEmail: form.email,
                    whatsappNumber: form.whatsapp,
                    scheduledAt: selSlot.iso,
                    note: `Scheduled live tour for ${property?.title}`,
                }),
            });
            if (!res.ok) throw new Error();
            onScheduled(selSlot);
        } catch {
            setError("Booking failed. Please try again.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="ltf-step ltf-schedule">
            <h3 className="ltf-section-title">📅 Book a Live Tour Slot</h3>
            {noticeBlock}
            <p className="ltf-sub">Pick a date and time — our agent will call you via video.</p>

            <div className="ltf-date-row">
                {dates.map(d => {
                    const label = slots.find(s => s.date === d)?.dateStr || d;
                    return (
                        <button
                            key={d}
                            className={`ltf-date-pill${selDate === d ? " active" : ""}`}
                            onClick={() => {
                                setSelDate(d);
                                setSelSlot(null);
                            }}
                        >
                            {label}
                        </button>
                    );
                })}
            </div>

            <p className="ltf-slots-label">{activeDateLabel}</p>
            <div className="ltf-slots-grid">
                {daySlots.map(t => (
                    <button
                        key={t.iso}
                        className={`ltf-slot${selSlot?.iso === t.iso ? " active" : ""}`}
                        onClick={() => setSelSlot(t)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            {error && <div className="ltf-error">{error}</div>}

            <button
                className="ltf-submit-btn"
                onClick={handleBook}
                disabled={saving || !selSlot}
            >
                {saving ? <><span className="ltf-spinner"/> Booking…</> : "Confirm Slot →"}
            </button>

            <button className="ltf-back-link" onClick={onBack}>← Back</button>
        </div>
    );
}


function StepConfirmed({slot, form, property, onClose}) {
    return (
        <div className="ltf-step ltf-confirmed">
            <div className="ltf-check-circle" aria-hidden="true">✓</div>
            <h3 className="ltf-confirmed-title">Tour Scheduled!</h3>
            <p className="ltf-confirmed-sub">
                We'll remind you on WhatsApp +91{form.whatsapp}{form.email ? ` and by email (${form.email})` : ""} before the call.
            </p>

            <div className="ltf-confirmed-card">
                <div className="ltf-cc-row">
                    <span>🏠 Property</span>
                    <strong>{property?.title}</strong>
                </div>
                <div className="ltf-cc-row">
                    <span>📅 Date &amp; Time</span>
                    <strong>{slot?.label} · {slot?.dateStr || new Date(slot?.iso).toLocaleDateString("en-IN", {
                        weekday: "short",
                        month: "short",
                        day: "numeric"
                    })}</strong>
                </div>
                <div className="ltf-cc-row">
                    <span>👤 Name</span>
                    <strong>{form.fullName}</strong>
                </div>
                <div className="ltf-cc-row">
                    <span>📱 WhatsApp</span>
                    <strong>+91 {form.whatsapp}</strong>
                </div>
            </div>

            <p className="ltf-confirmed-note">
                A confirmation has been sent to your WhatsApp{form.email ? " and email" : ""}.
                Our agent will call you at the scheduled time.
            </p>

            <button className="ltf-submit-btn ltf-submit-btn--green" onClick={onClose}>
                Done
            </button>
        </div>
    );
}

/**
 * Live video tour request modal opened from a property listing. Walks the
 * visitor through entering contact details to request an on-demand agent
 * call, or booking a scheduled slot instead, and hands the accepted call's
 * room details back to the parent via onJoinCall.
 */
export default function LiveTourFormModal({property, onClose, onJoinCall}) {
    const [step, setStep] = useState("details");
    const [form, setForm] = useState(() => ({fullName: "", email: "", whatsapp: readStored(WHATSAPP_KEY)}));
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [slot, setSlot] = useState(null);
    const [online, setOnline] = useState(null);
    const [pending, setPending] = useState(null);
    const [notice, setNotice] = useState("");

    // Signed-in buyers shouldn't retype what we already know; fields they've started typing are left alone.
    useEffect(() => {
        const token = readStored("ogm_token");
        if (!token) return;
        fetch(`${API_BASE}/api/auth/me`, {headers: {Authorization: `Bearer ${token}`}})
            .then(r => (r.ok ? r.json() : null))
            .then(me => {
                if (!me) return;
                setForm(prev => ({
                    ...prev,
                    fullName: prev.fullName || me.fullName || "",
                    email: prev.email || me.email || "",
                }));
            })
            .catch(() => {});
    }, []);

    useEffect(() => {
        if (!property?.id) return;
        fetch(`${API_BASE}/api/live-tour/availability/${property.id}`)
            .then(r => (r.ok ? r.json() : null))
            .then(d => { if (d) setOnline(!!d.online); })
            .catch(() => {});
    }, [property?.id]);

    const handleChange = useCallback((field, value) => {
        setForm(prev => ({...prev, [field]: value}));
        setError("");
    }, []);

    const handleSubmit = async () => {
        if (!form.fullName.trim()) {
            setError("Please enter your name.");
            return;
        }
        if (!/^[6-9]\d{9}$/.test(form.whatsapp.trim())) {
            setError("Please enter a valid 10-digit WhatsApp number.");
            return;
        }
        setLoading(true);
        setError("");

        const room = generateRoomName(property?.slug);

        try {
            const token = readStored("ogm_token");
            const res = await fetch(`${API_BASE}/api/live-tour/request`, {
                method: "POST",
                headers: {"Content-Type": "application/json", ...(token ? {Authorization: `Bearer ${token}`} : {})},
                body: JSON.stringify({
                    propertyId:    property?.id,
                    propertyTitle: property?.title,
                    propertySlug:  property?.slug,
                    fullName:      form.fullName.trim(),
                    email:         form.email.trim() || null,
                    whatsappNumber:form.whatsapp.trim(),
                    roomName:      room,
                }),
            });
            if (res.status === 401) {
                setError("Your sign-in has expired. Please sign in again to start a live tour.");
                return;
            }
            if (!res.ok) {
                const body = await res.json().catch(() => null);
                setError(body?.error || "Something went wrong. Please try again.");
                return;
            }
            const data = await res.json();
            writeStored(WHATSAPP_KEY, form.whatsapp.trim());

            const activeRoom = data.roomName || room;
            if (data.agentsAvailable === false) {
                setPending({requestId: data.requestId, roomName: activeRoom});
                setNotice("All our advisors are busy right now. Pick a time and we'll call you on video then.");
                setStep("schedule");
                return;
            }
            setPending({requestId: data.requestId, roomName: activeRoom});
            setStep("connecting");
        } catch {
            setError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const joined = useCallback((agentName) => {
        onJoinCall?.({
            agentName: agentName || null,
            name:     form.fullName.trim(),
            initials: form.fullName.trim().split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2),
            property: property?.title,
            mobile:   form.whatsapp.trim(),
            email:    form.email.trim() || null,
            roomName: pending?.roomName,
            requestId: pending?.requestId,
        });
        onClose();
    }, [form, property, pending, onJoinCall, onClose]);

    // Closing the waiting screen (or choosing a slot instead) tells the server, so agents stop ringing for nobody.
    const cancelWaiting = useCallback(() => {
        if (step !== "connecting" || !pending?.requestId) return;
        fetch(`${API_BASE}/api/live-tour/request/${pending.requestId}/cancel`, {method: "POST", keepalive: true}).catch(() => {});
    }, [step, pending]);

    const close = useCallback(() => { cancelWaiting(); onClose(); }, [cancelWaiting, onClose]);

    const missed = useCallback(() => {
        setNotice("Sorry, no advisor could join just now. Pick a time and we'll call you on video then.");
        setStep("schedule");
    }, []);

    return (
        <div
            className="ltf-overlay"
            role="dialog"
            aria-modal="true"
            aria-label="Live video tour"
            onClick={e => e.target === e.currentTarget && close()}
        >
            <div className="ltf-modal">
                <button className="ltf-close" onClick={close} aria-label="Close">✕</button>

                {step === "details" && (
                    <StepDetails
                        form={form}
                        onChange={handleChange}
                        onSubmit={handleSubmit}
                        loading={loading}
                        error={error}
                        property={property}
                        online={online}
                    />
                )}

                {step === "connecting" && pending && (
                    <StepConnecting
                        pending={pending}
                        property={property}
                        onJoined={joined}
                        onMissed={missed}
                        onCancel={() => { cancelWaiting(); setNotice(""); setStep("schedule"); }}
                    />
                )}

                {step === "schedule" && (
                    <StepSchedule
                        requestId={pending?.requestId || null}
                        notice={notice}
                        property={property}
                        form={form}
                        onScheduled={(s) => { setSlot(s); setStep("confirmed"); }}
                        onBack={() => setStep("details")}
                    />
                )}

                {step === "confirmed" && (
                    <StepConfirmed
                        slot={slot}
                        form={form}
                        property={property}
                        onClose={onClose}
                    />
                )}
            </div>
        </div>
    );
}
